import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "underscoreToWhitespace" })
export class UnderscoreToWhitespacePipe implements PipeTransform {
    transform(value: string): string {
        return (value || "").replace(/_/g, " ");
    }
}
